var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.333 3.426a.833.833 0 0 0 0 1.667h.3c.398 0 .74.28.818.67l1.13 5.654a2.5 2.5 0 0 0 2.452 2.01h6.123a2.5 2.5 0 0 0 2.406-1.82l.857-3.03a2.083 2.083 0 0 0-2.005-2.65h-9.23l-.099-.491a2.5 2.5 0 0 0-2.451-2.01h-.3Zm3.883 7.664-.7-3.497h8.898c.276 0 .476.264.401.53l-.857 3.03a.833.833 0 0 1-.802.607H8.033a.833.833 0 0 1-.817-.67Zm.284 7.336a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333Zm6.667 0a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333Z",
    clipRule: "evenodd"
  })));
};
export { SvgCart as ReactComponent };
export default __webpack_public_path__ + "a4bc6ff537621c3321d50fe1be6fb663.svg";